import DUISnackbar from '@tencent/dui/lib/components/Snackbar';
import i18n from '@i18next/i18n';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { ShapePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/shape-property-converter';
import {
    IndentType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

export function getNewLevel(nP, type: string): number {
    let level = nP.paragraphProps.level || 0;
    type === IndentType.INDENT_INCREASE ? level += 1 : level -= 1;
    return level;
}

// eslint-disable-next-line complexity
export function handleParaIndentChange(para, type: string, shapeModel: IShapeModel) {
    const nP = { ...para };
    const currentLevel = nP.paragraphProps.level || 0;
    const level = getNewLevel(nP, type);
    if (level > 8) {
        DUISnackbar.show({
            message: i18n.t('缩进已达上限'),
            id: 'max-indent',
        });
        return nP;
    }
    if (level < 0) {
        DUISnackbar.show({
            message: i18n.t('缩进已达下限'),
            id: 'min-indent',
        });
        return nP;
    }
    nP.paragraphProps = {
        ...nP.paragraphProps,
        level,
        'raw-level': true, // 加上raw-标志，用以提交sdk时区分继承属性
    };
    // 获取当前 level 对应的 marginLeft
    const currentLevelMargin = ShapePropertyConverter.getInheritParagraphProps(shapeModel, currentLevel, ['marL'])?.marginLeft || 0;
    const diff = nP.paragraphProps.marginLeft - currentLevelMargin;
    // 如果和目前 marginLeft 相同，则删除自身的相关属性，level 修改之后，继承的 marginLeft 也会相应变化
    if (diff === 0) {
        delete nP.paragraphProps.marginLeft;
        delete nP.paragraphProps['raw-marginLeft'];
        return nP;
    }
    // 如果 diff 不为 0，需要基于新 level 对应的继承 marginLeft 来重新计算
    const inheritMarginLeft = ShapePropertyConverter.getInheritParagraphProps(shapeModel, level, ['marL'])?.marginLeft || 0;
    nP.paragraphProps = {
        ...nP.paragraphProps,
        marginLeft: inheritMarginLeft + diff,
        'raw-marginLeft': true, // 加上raw-标志，用以提交sdk时区分继承属性
    };
    return nP;
}
